import { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import BrowseHealers from '@/pages/BrowseHealers';
import HealerProfile from '@/pages/HealerProfile';
import PatientDashboard from '@/pages/PatientDashboard';
import HealerDashboard from '@/pages/HealerDashboard';
import PaymentSuccess from '@/pages/PaymentSuccess';
import JoinAsHealer from '@/pages/JoinAsHealer';
import AdminDashboard from '@/pages/AdminDashboard';
import ThemePreview from '@/pages/ThemePreview';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import ContactUs from '@/pages/ContactUs';
import SignUp from '@/pages/SignUp';
import Founders from '@/pages/Founders';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { Toaster } from '@/components/ui/sonner';

const ProtectedRoute = ({ children, requireHealer = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  if (requireHealer && user.role !== 'healer') {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/browse" element={<BrowseHealers />} />
      <Route path="/healer/:healerId" element={<HealerProfile />} />
      <Route path="/join-as-healer" element={<JoinAsHealer />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/theme-preview" element={<ThemePreview />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/founders/:code" element={<Founders />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <PatientDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/healer-dashboard"
        element={
          <ProtectedRoute requireHealer={true}>
            <HealerDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment-success"
        element={
          <ProtectedRoute>
            <PaymentSuccess />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;